import React, { useContext, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { get } from 'mobx';
import { pxToRem } from '../../../lib/_util/UnitConvertor';
import TableContext from './TableContext';
import { columnWidth, minColumnWidth } from './Column';
const TableCol = function TableCol(props) {
    const { column, last } = props;
    const { tableStore, prefixCls } = useContext(TableContext);
    const width = last && !tableStore.hasEmptyWidthColumn ? undefined : tableStore.overflowX ? columnWidth(column, tableStore) : get(column, 'width');
    const minWidth = minColumnWidth(column, tableStore);
    const style = useMemo(() => ({
        width: pxToRem(width),
        minWidth: pxToRem(minWidth),
    }), [width, minWidth]);
    return (React.createElement("col", { className: `${prefixCls}-col`, style: style }));
};
TableCol.displayName = 'TableCol';
export default observer(TableCol);
